export enum ArticleEmbedStateEnum {
  PENDING = 'pending',
  EMBEDDING = 'embedding',
  EMBEDDED = 'embedded',
  FAILED = 'failed',
}
